import styled from "styled-components";

export const AuctionStyled = styled.div`
  position: relative;
  margin-top: 12px;
  margin-bottom: 6px;

  select {
    width: 100%;
    border: none;
    appearance: none;
    background-color: #eaebed;
  }
  .arrow-cont {
    position: absolute;
    left: 12px;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
